import * as Sentry from "@sentry/browser";
import configureStore from "core-integration/src/configureStore";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router";
import App from "./components/App";
import D3AuthProvider from "./providers/D3AuthProvider";
import "./i18n";
import * as serviceWorker from "./serviceWorker";

if (import.meta.env.VITE_SENTRY_ENVIRONMENT) {
  Sentry.init({
    dsn: "https://5989fdf4d706b78ebd5e45fe2a7f7785@o118622.ingest.sentry.io/4506111474991105",
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    integrations: [
      new Sentry.BrowserProfilingIntegration(),
      new Sentry.BrowserTracing(),
    ],
    ignoreErrors: [/gtag is not defined/],
    maxBreadcrumbs: 50,
    tracesSampleRate: 0.000002,
    profilesSampleRate: 0.000002,
  });
}

const container = document.getElementById("root")!;
const root = createRoot(container);

// Create a data router to support useBlocker hook
const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <Provider store={configureStore()}>
        <D3AuthProvider>
          <App />
        </D3AuthProvider>
      </Provider>
    ),
  },
]);

root.render(<RouterProvider router={router} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
